import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import React from 'react'
import moment from 'moment';
import Link from 'next/link';
const quickSand = Quicksand({weight:"400",subsets:['latin']});
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "600", subsets: ['latin']});
export default function Batchtime(props) {


    // Regular Batch
 
    const getRegularBatch = () => {
        const today = moment();
        const daysUntilMonday = (7 - today.day() + 1) % 7; // Calculate days until next Monday
        return today.add(daysUntilMonday, 'days');
      };

      // Get the next Monday's date and month
const nextMonday = getRegularBatch();
const nextMondayDate = nextMonday.format('DD');
const nextMondayMonth = nextMonday.format('MMM');

    //   Week END bATCH

    const getWeekEndBatch = () => {
        const today = moment();
        const daysUntilSaturday = (6 - today.day() ) % 7; // Calculate days until next Saturday
        return today.add(daysUntilSaturday, 'days');
      };
     
      // Get the next Saturday's date and month
      const nextSaturday = getWeekEndBatch();
      const nextSaturdayDate = nextSaturday.format('DD');
      const nextSaturdayMonth = nextSaturday.format('MMM');

      const batches = [
        {
            type: 'Regular Batch',
            days: 'Mon - Fri',
            time: 'One Hour',
            duration: '3 Months',
            date: nextMondayDate,
            month: nextMondayMonth
        },
        {
            type: 'Weekend Batch',
            days: 'Sat & Sun',
            time: 'Two Hours',
            duration: '3 Months',
            date: nextSaturdayDate,
            month: nextSaturdayMonth
        },
    ]

  return (
<>

<section className='batches-bg mt80 mmt40'>

<div className='container'>



<div className='df pdt40 fjsb mfw mpdt10'>
    <div className='mdf mfdc '>
        <h2 className={`fs-40 mfs22 tac mtal lh5 mlhs30 mpdb10 ${popins.className}`}>Upcoming {props.title} Course Batches</h2>
        <div className='df pdt24 mfdc fjsa mfjfs mpdt5'>

            <div className=''>
            <div className='df '>
            <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"40"} height={"40"} loading='lazy'/>
            </div>
            <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"13"} height={"13"} loading='lazy'/>
            </div>
            <div className='df fac'>
            <h3 className={`fs-20 mfs-16 pdl16 mpdl10 ${popins.className}`}>Regular Batch</h3>
            </div>
            </div>

            <div className='df pdt24 mpdt12'>
            <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"40"} height={"40"} loading='lazy'/>
            </div>
            <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"13"} height={"13"} loading='lazy'/>
            </div>
            <div className='df fac'>
            <h3 className={`fs-20 mfs-16 pdl16 mpdl10 ${popins.className}`}>Weekend Batch</h3>
            </div>
            </div>
            </div>

            <div className=''>
            <div className='df mpdt12'>
            <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"40"} height={"40"} loading='lazy'/>
            </div>
            <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"13"} height={"13"} loading='lazy'/>
            </div>
            <div className='df fac'>
            <h4 className={`fs-20 mfs-16 pdl16 mpdl10 ${popins.className}`}>Customizable Schedule</h4>
            </div>
            </div>

            <div className='df pdt24 mpdt12'>
            <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"40"} height={"40"} loading='lazy'/>
            </div>
            <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batches-icon.webp"} alt='Bacthe-Icon' width={"13"} height={"13"} loading='lazy'/>
            </div>
            <div className='df fac'>
            <h4 className={`fs-20 mfs-16 pdl16 mpdl10 ${popins.className}`}>Fast Track Schedule</h4>
            </div>
            </div>
            </div>
        </div>
    </div>

{/* Batches Price Box */}
{/* <div className='pdt10 mpdt0'>
    <div className='batches-box mmt25 mpd5'>
        <div className='df fjsa'>
        <div className='pdt25 pdl24 mpdl0 mpdt10 '>
           {props.fees && ( <><div className='line1 blink-animation'></div><h6 className={`fs-19 mfs-14 ${popins.className}`}><span>&#8377;</span> {props.fees}</h6></> )}
            <h4 className={`fs-45 mfs-22 pdt10 mpdt4 ${extraPopins.className}`}><span>&#8377;</span> {props.offer}</h4>
            <div className='df fjc fac pdt10 dn mdb'>
       <button className={`cnt-btn fs-14 mfs-11 ${quickSand.className}`}>Contact Us</button>
       </div>
        </div>
        <div className=" pdl24  pdt10 df fdc fac">
        <div className="logo mdn">
        <Image src={"/course-img/Upcoming-Batches-imgs/logo-icon.webp"} alt='Logo' width={"100"} height={"103"} loading='lazy'/> 
        </div>
        <div className="logo dn mdb">
        <Image src={"/course-img/Upcoming-Batches-imgs/logo-icon.webp"} alt='Logo' width={"80"} height={"83"} loading='lazy'/> 
        </div>
        </div>
        </div>
        <div className='df fjc pdt10 mdn'>
        <Link href={"/contact"}>
       <button className={`cnt-btn fs-19 mfs-11 ${popins.className}`}>Contact Us</button>
       </Link>
       </div>
    </div>
    </div> */}
</div>


{/* Batches Schedule Box */}

<div className='mt40 df gap32 mfdc mfac mfjc mmt25 mgap10'>

    {batches.map((items,index)=>{
        return(
<div className='schedule-box ' key={index}>

<div className='pd24 mpd10  df fjsb mfjsa'>

{/* Batches Month And Time Box */}

    <div className='mdf mfac mpdr10'>
        <div>
        <div className='mnth-box df fac fjc'>
          <h5 className={`fs-33 mfs-16 cw ${extraPopins.className}`}>{items.date}</h5>
        </div>
        <div className='date-box df fac fjc'>
          <h5 className={`fs-33 mfs-16 cw ${extraPopins.className}`}>{items.month}</h5>
        </div>
        </div>
    </div>
<div className='mdf mfac'>
    <div>
    <h6 className={`fs-20 ylw-clr mfs-16 ${extraPopins.className}`}>{props.title} Course</h6>
    <h4 className={`fs40 mfs-19 dark-clr pdt30 mpdt0 ${popins.className}`}>{items.type}</h4>

    <div className='pdt30 mpdt0 df gap10 mgap5 fac'>
        <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batch-arrow-icon.webp"} alt='Arrow-Icon' width={"21"} height={"24"} loading='lazy'/>
        </div>
        <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batch-arrow-icon.webp"} alt='Arrow-Icon' width={"10"} height={"12"} loading='lazy'/>
        </div>
        <p className={`fs-16 mfs-10 ylw-clr ${popins.className}`}>{items.days}</p>
        <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batch-arrow-icon.webp"} alt='Arrow-Icon' width={"21"} height={"24"} loading='lazy'/>
        </div>
        <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batch-arrow-icon.webp"} alt='Arrow-Icon' width={"10"} height={"11"} loading='lazy'/>
        </div>
        <p className={`fs-16 mfs-10 ylw-clr ${popins.className}`}>{items.time}</p>
        <div className='mdn'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batch-arrow-icon.webp"} alt='Arrow-Icon' width={"21"} height={"24"} loading='lazy'/>
        </div>
        <div className='dn mdb'>
            <Image src={"/course-img/Upcoming-Batches-imgs/batch-arrow-icon.webp"} alt='Arrow-Icon' width={"10"} height={"11"} loading='lazy'/>
        </div>
        <p className={`fs-16 mfs-10  ylw-clr ${popins.className}`}>{items.duration}</p>
        </div>
    </div>
    
</div>

</div>

</div>

)
    })}


</div>

</div>


</section>

<style jsx>
    {`
    .blink-animation {
        animation: blink 1s infinite; /* Adjust the duration as needed */
      }
  
      @keyframes blink {
        0%, 100% {
          border-bottom: 2px solid transparent; /* Invisible at the start and end */
        }
        50% {
          border-bottom: 2px solid #FF0000; /* Visible in the middle */
        }
      }
  

.date-box{
    width: 137px;
    height:82px;
    border-radius:0px 0px 16px 16px;
    border-bottom: 1px solid #FFFFFF;
    background-color: #FF8100; 
    box-shadow: 0px 4px 10px 0px #00000040;

}
    .mnth-box{
        width: 137px;
        height:82px;
        border-radius:16px 16px 0px 0px;
        border-bottom: 1px solid #FFFFFF;
        background-color: #FFA100;
        box-shadow: 0px 4px 10px 0px #00000040;

    }

.schedule-box{
    width: 604px;
    height: 213px;
    background-color: #FFFFFF;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px #FFFFFF40;
    margin-bottom:20px;
}

.cnt-btn{
    width:138px;
    height: 40px;
    border: 1px solid #090909;
    border-radius: 4px;
    background-color: transparent;
    cursor:pointer;
    transition : all 0.4s linear;
}

.cnt-btn:hover{
    background-color:#FFFFFF;
    color:#FFA900;
    box-shadow: 0px 0px 6px 9px #fdbb3940;
}


    .line1 {
        width: 86px;
        height: 14px;
        border-bottom: 1px solid #FF0000;
        -webkit-transform: translateY(-4px) translateX(-1px) rotate(-10deg);
        position: absolute;
       
        
      }
    .batches-bg{
        background-image:url("/course-img/Upcoming-Batches-imgs/batches-bg.webp");
        width:100%;
        height: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .batches-box{
        width: 392px;
        height: 179px;
        border: 2px solid #0D0D0D;
        border-radius: 32px;

    }

    @media only screen and (max-width: 1023px){
        .batches-bg{
            background-image:url("/course-img/Upcoming-Batches-imgs/batches-bg.webp");
            width:100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            padding-bottom: 20px;
        }
        .batches-box{
            width: 280px;
            height: 98.59px;
            border: 1px solid #0D0D0D;
            border-radius: 15px;
    
        }
        .cnt-btn{
            width:68px;
            height: 19px;
            border: 0.9px solid #090909;
            border-radius: 1.98px;
            background-color: transparent;
            cursor:pointer;
        }
        .line1 {
            width: 55px;
            height: 14px;
            border-bottom: 1px solid #FF0000;
            -webkit-transform: translateY(-6px) translateX(6px) rotate(-10deg);
            position: absolute;
           
            
          }
        .schedule-box{
            width: 100%;
            height: 100%;
            background-color: #FFFFFF;
            border-radius: 11px;
            box-shadow: 0px 4px 10px 0px #FFFFFF40;
        
        }
        .date-box{
            width: 65px;
            height:42px;
            border-radius:0px 0px 7px 7px;
            border-bottom: 0.48px solid #FFFFFF;
            background-color: #FF8100; 
            box-shadow: 0px 2px 5px 0px #00000020;
        
        }
            .mnth-box{
                width: 65px;
                height:42px;
                border-radius:7px 7px 0px 0px;
                border-bottom: 0.48px solid #FFFFFF;
                background-color: #FFA100;
                box-shadow: 0px 4px 10px 0px #00000040;
        
            }
        

    }
    
    
    `}
</style>

</>
  )
}
